<div class="modal-header">
	<h2 [ro-i18n] eikey="dashboard.password.title"></h2>
</div>
<div class="modal-body">
	<form [formGroup]="passwordForm" novalidate (ngSubmit)="onSubmit()" class="needs-validation">
		<div class="row">
			<div class="form-group col-md-6">
				<label class="col-form-label" for="password" [ro-i18n] eikey="dashboard.password.labels.password">Password</label>
				<input class="form-control"
					id="password"
					type="password"
					formControlName="password"
					placeholder="{{ placeholders.password }}"
					required
					[ngClass]="{ 'is-invalid': submitted && formControls.password.errors, 'is-valid': formControls.password.touched && !formControls.password.errors }" />
				<div *ngIf="submitted && formControls['password'].errors" class="invalid-feedback">
					<div *ngIf="formControls['password'].errors?.required" [ro-i18n] eikey="dashboard.password.errorMsgs.passwordReq">Password is required</div>
					<div *ngIf="formControls['password'].errors?.pattern" [ro-i18n] eikey="dashboard.password.errorMsgs.invalidPassword">bad pwd</div>
				</div>
			</div>
			<div class="form-group col-md-6">
				<label class="col-form-label" for="confirmPassword" [ro-i18n] eikey="dashboard.password.labels.confirm">Confirm password</label>
				<input class="form-control"
					id="confirmPassword"
					type="password"
					formControlName="confirmPassword"
					placeholder="{{ placeholders.confirm }}"
					required
					[ngClass]="{ 'is-invalid': submitted && passwordForm.errors, 'is-valid': formControls.confirmPassword.touched && !passwordForm.errors }" />
				<div *ngIf="submitted && passwordForm.errors" class="invalid-feedback">
					<div *ngIf="formControls['confirmPassword'].errors?.required" [ro-i18n] eikey="dashboard.password.errorMsgs.passwordReq">Confirm password is required</div>
					<div *ngIf="passwordForm.errors['passwordMismatch']" [ro-i18n] eikey="dashboard.password.errorMsgs.passwordMismatch">mismatch</div>
				</div>
			</div>
		</div>
	</form>
</div>
<div class="modal-footer">
	<div class="form-group">
		<div class="row">
			<div class="col-md-12">
				<button class="btn btn-primary mr-1" (click)="onSubmit()" type="submit" [ro-i18n] eikey="general.save" [disabled]="passwordForm.pristine">Submit</button>
				<button class="btn button-dark" type="cancel" (click)="onCancel()" aria-label="Close" [ro-i18n] eikey="general.cancel">Close</button>
			</div>
		</div>
		<div class="row">
			<div class="sk-rotating-plane col-md-12" [hidden]="!submitting"></div>
		</div>
		<div class="row" style="margin-top: 35px;">
			<div class="col-md-12">
				<alerts [namespace]="'password-modal'"></alerts>
			</div>
		</div>
	</div>

</div>
